import { createSlice } from "@reduxjs/toolkit";
import { fetchGsts, fetchGstById, updateGst, updateStatusInGst, fetchGstByDropDown } from "./thunk";

interface gstState {
  gstList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedgst: any;
}

const initialState: gstState = {
  gstList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedgst: null,
};

const gstSlice = createSlice({
  name: "gst",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGsts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGsts.fulfilled, (state, action) => {
        state.loading = false;
        state.gstList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchGsts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch gsts";
      })
      .addCase(fetchGstById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGstById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedgst = action.payload;
      })
      .addCase(fetchGstById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateGst.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.gstList = state.gstList.map((gst) =>
          gst.id === action.payload.id ? action.payload : gst
        );
      })
      .addCase(updateGst.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update gst";
      })
      .addCase(updateStatusInGst.fulfilled, (state, action) => {
        // if (!action.payload?.id) return;
        // state.gstList = state.gstList.map((gst) =>
        //   gst.id === action.payload.id ? action.payload : gst
        // );
      })
      .addCase(updateStatusInGst.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })
      .addCase(fetchGstByDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGstByDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.gstList = action.payload.data;
      })
      .addCase(fetchGstByDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default gstSlice.reducer;
